import { CORE_PROJECT } from '@atlassian/jira-common-constants/src/project-types.tsx';

const TEMPLATE_BLANK_PROJECT_TEAM_MANAGED =
	'com.atlassian.jira-core-project-templates:jira-work-management-blank-project-team-managed' as const;

export const getJwmCreateProjectDrawerOptions = (
	source: string,
	recommendationSessionId?: string,
) => ({
	isNextGen: true,
	selectedProjectType: CORE_PROJECT,
	showExperienceSelection: false,
	defaultSelectedTemplateKey: TEMPLATE_BLANK_PROJECT_TEAM_MANAGED,
	recommendedTemplate: {
		templateKey: TEMPLATE_BLANK_PROJECT_TEAM_MANAGED,
		isSimplified: false,
	},
	source,
	recommendationSessionId,
});
